import * as types from './mutation-types'

export default {
  [types.SET_BRAND](state, payload = { brand }) {
    state.brand = payload.brand
  },
}
